// extracted by mini-css-extract-plugin
export default {"container":"SearchPanel_container__Q2nCQ","list":"SearchPanel_list__MijrV"};